// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";
import * as CategoryTiles__Settings$PrezzeeRibbon from "./CategoryTiles__Settings.bs.js";

var spacing = BsCssJs$PrezzeeRibbon.px(34);

var verticalOffsetPx = BsCssJs$PrezzeeRibbon.px(CategoryTiles__Settings$PrezzeeRibbon.verticalOffset);

function blockWrapper(amount) {
  var mobileLayout = amount > 2 ? BsCssJs$PrezzeeRibbon.gridTemplateColumns([
          BsCssJs$PrezzeeRibbon.fr(1),
          BsCssJs$PrezzeeRibbon.fr(1)
        ]) : BsCssJs$PrezzeeRibbon.gridTemplateColumns([BsCssJs$PrezzeeRibbon.fr(1)]);
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.display("grid"),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletOrDesktop, [
                    BsCssJs$PrezzeeRibbon.gridTemplateColumns([{
                            NAME: "repeat",
                            VAL: [
                              {
                                NAME: "num",
                                VAL: amount
                              },
                              BsCssJs$PrezzeeRibbon.fr(1)
                            ]
                          }]),
                    BsCssJs$PrezzeeRibbon.columnGap(spacing),
                    BsCssJs$PrezzeeRibbon.rowGap(spacing),
                    BsCssJs$PrezzeeRibbon.paddingTop(BsCssJs$PrezzeeRibbon.px(30)),
                    BsCssJs$PrezzeeRibbon.paddingBottom(BsCssJs$PrezzeeRibbon.px(30)),
                    BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(-30)),
                    BsCssJs$PrezzeeRibbon.marginBottom(BsCssJs$PrezzeeRibbon.px(-30))
                  ]),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletOrMobile, [
                    BsCssJs$PrezzeeRibbon.columnGap(BsCssJs$PrezzeeRibbon.px(12)),
                    BsCssJs$PrezzeeRibbon.rowGap(BsCssJs$PrezzeeRibbon.px(12))
                  ]),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletSm, [mobileLayout])
            ]);
}

function computeOffset(i) {
  if (i % 2 === 1) {
    return BsCssJs$PrezzeeRibbon.style([
                BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletSmUp, [BsCssJs$PrezzeeRibbon.marginTop(verticalOffsetPx)]),
                BsCssJs$PrezzeeRibbon.media(CategoryTiles__Settings$PrezzeeRibbon.heightCuttoffQuery, [BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.zero))])
              ]);
  } else {
    return BsCssJs$PrezzeeRibbon.style([]);
  }
}

var Styles = {
  spacing: spacing,
  verticalOffsetPx: verticalOffsetPx,
  blockWrapper: blockWrapper,
  computeOffset: computeOffset
};

function CategoryTiles(props) {
  var wrapperClassName = props.wrapperClassName;
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  var wrapperClassName$1 = wrapperClassName !== undefined ? wrapperClassName : "";
  var tiles = React.Children.toArray(props.children);
  var individualTiles = Belt_Array.mapWithIndex(tiles, (function (i, tile) {
          var className = Classnames([
                computeOffset(i),
                wrapperClassName$1
              ]);
          return JsxRuntime.jsx("div", {
                      children: tile,
                      className: className
                    }, String(i));
        }));
  return JsxRuntime.jsx("div", {
              children: individualTiles,
              className: Classnames([
                    blockWrapper(tiles.length),
                    className$1
                  ])
            });
}

var Settings;

var Single;

var make = CategoryTiles;

export {
  Settings ,
  Single ,
  Styles ,
  make ,
}
/* spacing Not a pure module */
